import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { getFieldMessage } from '@/utils/message'
import { login } from '@/api/userApi'

export function useLoginLogic() {
  const router = useRouter()
  const userStore = useUserStore()

  const onSubmit = async (values: { loginName: string; password: string }) => {
    try {
      const response = await login({ loginName: values.loginName, password: values.password })
      const messageIds = 'message_ids' in response ? response.message_ids : []
      if (messageIds.length > 0) {
        return { serverErrorMessage: getFieldMessage(messageIds) }
      }

      await userStore.fetchUserInfo()
      router.push('/weather-over-view')
      return { serverErrorMessage: '' }
    } catch {
      // callApi 内で ErrorStore にセット済みのため何もしない
      return
    }
  }
  return { onSubmit }
}
